import React from 'react';

const SkipLink = () => {
  return (
    <a
      href="#main-content"
      className="sr-only focus:not-sr-only focus:fixed focus:top-4 focus:left-4 z-[100] px-6 py-3 bg-white text-slate-900 font-bold rounded-lg shadow-xl border-2 border-slate-900 outline-none focus:ring-4 focus:ring-slate-300 transition-all"
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;